/* global define */

define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'moment',
  'es6!launcher/actions/AnalyticsActions',
], (Util, Immutable, _, moment, Actions) => {
  const initialState = Immutable.Map({
    activePage: null,
    chartData: null,
  });

  const actionHandlers = {};

  actionHandlers[Actions.UPDATE_SETTING] = (state, action) => {
    const settingName = action.setting;
    const settingValue = action.value;

    if (!settingName) return state;
    return state.setIn([settingName], settingValue);
  };

  return Util.createReducer(initialState, actionHandlers);
});

